import AccountsApiService from '@/services/accountsApi';
import _get from 'lodash/get';

const mixin = {
    data() {
        return {
            passwordValidationRetrievingPolicies: false,
            passwordValidationSettings: {},
            passwordValidPolicies: {}
        };
    },
    computed: {
        passwordValidationComplexity() {
            return _get(this.passwordValidationSettings, 'complexity', {});
        },
        passwordValidationRules() {
            let rules = [];
            
            if (this.passwordValidationComplexity.minLength) {
                rules.push((value) => { return this.validatePasswordMinLength(value) });
            }

            if (this.passwordValidationComplexity.minLowerCase) {
                rules.push((value) => { return this.validatePasswordMinLowerCase(value) });
            }

            if (this.passwordValidationComplexity.minUpperCase) {
                rules.push((value) => { return this.validatePasswordMinUpperCase(value) });
            }

            if (this.passwordValidationComplexity.minNumber) {
                rules.push((value) => { return this.validatePasswordMinNumber(value) });
            }

            if (this.passwordValidationComplexity.minSymbol) {
                rules.push((value) => { return this.validatePasswordMinSymbol(value) });
            }

            return rules;
        }
    },
    methods: {
        passwordValidationRetrievePasswordSettings() {
            this.passwordValidationRetrievingPolicies = true;

            return AccountsApiService.getPasswordSettings()
                .then((result) => {
                    this.passwordValidationSettings = result;
                })
                .catch((e) => {

                })
                .finally(() => {
                    this.passwordValidationRetrievingPolicies = false;
                });
        },
        passwordValidationCharacterTypeCount(input) {
            let symbolCount = 0;
            let numberCount = 0;
            let lowercaseCount = 0;
            let uppercaseCount = 0;
            let length = 0;

            if (input) {
                input.split('').forEach((letter) => {
                    length++;
                    if (/[#?!@$%^&*-]+/.test(letter)) {
                        symbolCount++;
                    } else if (/[0-9]+/.test(letter)) {
                        numberCount++;
                    } else if (/[A-Z]+/.test(letter)) {
                        uppercaseCount++;
                    } else if (/[a-z]+/.test(letter)) {
                        lowercaseCount++;
                    }
                })
            }

            return {
                length,
                symbolCount,
                numberCount,
                lowercaseCount,
                uppercaseCount
            }
        },
        validatePasswordMinLength(value) {
            this.$forceUpdate();
            if (this.passwordValidationCharacterTypeCount(value).length >= this.passwordValidationComplexity.minLength) {
                this.passwordValidPolicies.minLength = true;
                return true;
            }
            this.passwordValidPolicies.minLength = false;
            return `${this.passwordValidationComplexity.minLength} characters minimum.`;
        },
        validatePasswordMinLowerCase(value) {
            this.$forceUpdate();
            if (this.passwordValidationCharacterTypeCount(value).lowercaseCount >= this.passwordValidationComplexity.minLowerCase) {
                this.passwordValidPolicies.minLowerCase = true;
                return true;
            }
            this.passwordValidPolicies.minLowerCase = false;
            return `${this.passwordValidationComplexity.minLowerCase} lowercase character${this.passwordValidationComplexity.minLowerCase === 1 ? '' : 's'} required.`;
        },
        validatePasswordMinUpperCase(value) {
            this.$forceUpdate();
            if (this.passwordValidationCharacterTypeCount(value).uppercaseCount >= this.passwordValidationComplexity.minUpperCase) {
                this.passwordValidPolicies.minUpperCase = true;
                return true;
            }
            this.passwordValidPolicies.minUpperCase = false;
            return `${this.passwordValidationComplexity.minUpperCase} uppercase character${this.passwordValidationComplexity.minUpperCase === 1 ? '' : 's'} required.`;
        },
        validatePasswordMinNumber(value) {
            this.$forceUpdate();
            if (this.passwordValidationCharacterTypeCount(value).numberCount >= this.passwordValidationComplexity.minNumber) {
                this.passwordValidPolicies.minNumber = true;
                return true;
            }
            this.passwordValidPolicies.minNumber = false;
            return `${this.passwordValidationComplexity.minNumber} number${this.passwordValidationComplexity.minNumber === 1 ? '' : 's'} required.`;
        },
        validatePasswordMinSymbol(value) {
            this.$forceUpdate();
            if (this.passwordValidationCharacterTypeCount(value).symbolCount >= this.passwordValidationComplexity.minSymbol) {
                this.passwordValidPolicies.minSymbol = true;
                return true;
            }
            this.passwordValidPolicies.minSymbol = false;
            return `${this.passwordValidationComplexity.minSymbol} symbol character${this.passwordValidationComplexity.minSymbol === 1 ? '' : 's'} required.`;
        }
    }
};

export default mixin;
